// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntbody tr[data-v-50f6ad76]:nth-of-type(odd) {\n  background-color: rgba(0, 0, 0, 0.05) !important;\n}\n", ""]);
// Exports
module.exports = exports;
